import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { CreateClientByVendorPayload } from "../../payload/CreateClientByVendor/CreateClientByVendorPayload";

const createByVendorFecth = (state: ClientsState, actions: PayloadAction<CreateClientByVendorPayload>) => {
    state.isLoading = true;
}

export default createByVendorFecth;